import { Navigate } from "react-router-dom";
import React from "react";
import { getNavigationPath } from "../functions";
import { useProjectInfo } from "app/views/components/hooks/useProjectInfo";

export const NaviageToAvailablePath: React.FC = () => {
    const { hasPlans } = useProjectInfo();
    const toUri = getNavigationPath(hasPlans);
    return <Navigate to={toUri} />
}